<div *ngIf="!childConfig.isHidden" class="tml-tpl-ctrl-wrap">
    <div class="tam-contact-control">
        <kendo-dropdownlist [style.width.px]="childConfig.css.leftWidth" [popupSettings]="{appendTo: 'component'}"
            #dropDownEl [(ngModel)]="childConfig.config.defaultValue" class="contact-dropdown" [disabled]="true">
        </kendo-dropdownlist>
    </div>

    <div class="tam-contact-control">
        <input class="tam-input" [style.width.px]="childConfig.css.rightWidth" [disabled]="true" />
    </div>
</div>